export default "__VITE_ASSET__zq7ttA7y__"